import fetchHelper from './fetchHelper.js';

async function jsonFetch({
  body,
  headers = {},
  method,
  url,
  language = 'en_US',
}) {
  return fetchHelper({
    body: body && JSON.stringify(body),
    contentType: 'application/json',
    headers,
    method,
    url,
    language,
  });
}

export default jsonFetch;
